module.exports = __webpack_public_path__ + "assets/apply-file.83639b1a.svg";